/* global axios */
import ApiClient from './ApiClient';

class DeclarativeAutomationsAPI extends ApiClient {
  constructor() {
    super('declarative_automation_rules', { accountScoped: true });
  }

  clone(automationId) {
    return axios.post(`${this.url}/${automationId}/clone`);
  }
}

export default new DeclarativeAutomationsAPI();
